'use client'

import type { ReactNode } from 'react'
import { AdminGuard } from './_components/admin-guard'
import { AdminShell } from './_components/shell'

/** Every screen in this group is behind the admin guard and inside the panel shell. */
export default function AdminLayout({ children }: { children: ReactNode }) {
    return (
        <AdminGuard>
            <AdminShell>{children}</AdminShell>
        </AdminGuard>
    )
}
